import { render } from "./ComplianceKeywords.vue?vue&type=template&id=d4bd131a&scoped=true"
import script from "./ComplianceKeywords.vue?vue&type=script&lang=js"
export * from "./ComplianceKeywords.vue?vue&type=script&lang=js"

import "./ComplianceKeywords.vue?vue&type=style&index=0&id=d4bd131a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4bd131a"]])

export default __exports__